module.exports = __webpack_public_path__ + "img/google.c86a4c67.svg";